export const CFE_TYPES = {
  101: "e-Ticket",
  102: "N/C e-Ticket",
  103: "N/D e-Ticket",
  111: "e-Factura",
  112: "N/C e-Factura",
  113: "N/D e-Factura",
  121: "e-Factura Exportación",
  122: "N/C e-Factura Exportación",
  123: "N/D e-Factura Exportación",
  124: "N/C e-Factura Exportación",
  131: "e-Ticket Exportación",
  132: "N/C e-Ticket Exportación",
  133: "N/D e-Ticket Exportación",
  141: "e-Factura Compra",
  142: "N/C e-Factura Compra",
  143: "N/D e-Factura Compra",
  151: "e-Ticket Compra",
  152: "N/C e-Ticket Compra",
  153: "N/D e-Ticket Compra",
  181: "e-Remito",
  182: "e-Resguardo",
  201: "e-Ticket Contingencia",
  202: "N/C e-Ticket Contingencia",
  203: "N/D e-Ticket Contingencia",
  211: "e-Factura Contingencia",
  212: "N/C e-Factura Contingencia",
  213: "N/D e-Factura Contingencia",
  221: "e-Factura Exp. Contingencia",
  222: "N/C e-Factura Exp. Contingencia",
  223: "N/D e-Factura Exp. Contingencia",
  224: "N/C e-Factura Exp. Contingencia",
  231: "e-Ticket Exp. Contingencia",
  232: "N/C e-Ticket Exp. Contingencia",
  233: "N/D e-Ticket Exp. Contingencia",
  241: "e-Factura Compra Contingencia",
  242: "N/C e-Factura Compra Contingencia",
  243: "N/D e-Factura Compra Contingencia",
  251: "e-Ticket Compra Contingencia",
  252: "N/C e-Ticket Compra Contingencia",
  253: "N/D e-Ticket Compra Contingencia",
  281: "e-Remito Contingencia",
  282: "e-Resguardo Contingencia",
};
